/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { updatePlanWhenUserUpdateFromCustomComponent } from '../../store/actions';

export default (props) => {
  const dispatch = useDispatch();
  const updateValueWhenUserUpdate = (data) =>
    dispatch(updatePlanWhenUserUpdateFromCustomComponent(data));
  const checkedHandler = (e) => {
    const { value } = e.target;
    const { colId } = props.column;
    props.node.setDataValue(colId, value);
    updateValueWhenUserUpdate({ ...props.data, updateRecord: true });
  };
  const allRebateProgramCode = useSelector((state) => {
    return state.sharedState.PlanReducer.allRebateProgramCode;
  });

  return (
    <div data-testid="mfg-select-box">
      <TextField
        id={`contact_type_${props.rowIndex}`}
        label="Contact Type"
        fullWidth
        select
        placeholder=""
        inputProps={{ maxlength: 11, id: `contact_type_${props.rowIndex}` }}
        InputLabelProps={{
          shrink: true,
          className: 'm-0 hide-elm',
          style: { visibility: 'hidden', position: 'absolute' },
        }}
        value={props.value || '-1'}
        onChange={checkedHandler}
        disabled={!props.isEnablebyRole}
      >
        <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
        {allRebateProgramCode &&
        allRebateProgramCode.length &&
        allRebateProgramCode.length > 0
          ? allRebateProgramCode.map((item) => {
              return (
                <MenuItem
                  key={item.rebateProgramCd}
                  value={item.rebateProgramCd}
                >
                  {item.rebateProgramCd}
                </MenuItem>
              );
            })
          : null}
      </TextField>
    </div>
  );
};
